import { connect } from 'react-redux';

import { basketSelectors } from '@store/basket/selectors';
import Rates from './Rates';

const mapStateToProps = (state) => ({
  roomIdsInBasket:
    basketSelectors.getBasketDetails(state)?.items?.map((room) => room?.bookable?.ids?.roomId) ||
    [],
});

export const RatesContainer: any = connect(mapStateToProps, null, null, { forwardRef: true })(
  Rates
);
